let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("dkV2T"), load("kgJcP")]).then(() => parcelRequire('4azDt'));